
import { Component, Vue, Prop } from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-list-toolbar',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop({ required: false }) readonly blockId: number;
  @Prop({ required: true }) readonly dataSource: string;
  @Prop({ default: 'top' }) readonly type: string;

  private get totalProductCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }

  private mounted(): void {
    const placeholder = document.getElementById('toolbarPlaceholder');
    if (placeholder) {
      placeholder.style.display = 'none';
    }
  }
}
